import React from 'react';
import '../../styles/sections/philosophy/PhilosophySection.css';

const PhilosophySection = ({
  title = "NUESTRA FILOSOFÍA",
  subtitle = "Nuestra manera de ver el mundo y trabajar",
  leftColumn = [
    <>Somos <strong>JIDDU FILMS</strong>, una productora creativa con base en Miami, enfocada en <strong>dirección visual</strong>, <strong>creación de contenido</strong> y <strong>entregas en tiempo real</strong>.</>,
    <>Diseñamos narrativa audiovisual con timing y precisión para <strong>ligas deportivas</strong>, <strong>campañas globales</strong>, <strong>festivales</strong> y marcas que necesitan comunicar con impacto y velocidad. Operamos con estructura ágil, recursos propios y una mirada que combina ejecución técnica con claridad editorial.</>
  ],
  rightColumn = [
    <><strong>Trabajamos en vivo, en locación o detrás de escena</strong>, y transformamos lo que sucede en contenido relevante, diseñado para cada plataforma y contexto.</>,
    <>Al frente está <strong>Matías Piccinini</strong>, director con formación en cine, comunicación y estrategia de marca. Con experiencia en televisión, publicidad, medios internacionales y contenidos en vivo, lidera un equipo que entiende de ritmo, estética y dirección creativa aplicada a la acción real.</>
  ],
  className = ''
}) => {
  return (
    <section className={`philosophy-section ${className}`}>
      <div className="philosophy-section__container">
        <div className="philosophy-section__content">
          {/* Section Header */}
          <div className="philosophy-section__header">
            <h2 className="philosophy-section__title">{title}</h2>
            <p className="philosophy-section__subtitle">{subtitle}</p>
          </div>

          {/* Two Columns Content */}
          <div className="philosophy-section__columns">
            <div className="philosophy-section__column philosophy-section__column--left">
              {Array.isArray(leftColumn) ? (
                leftColumn.map((paragraph, index) => (
                  <p key={index} className="philosophy-section__text">
                    {paragraph}
                  </p>
                ))
              ) : (
                <p className="philosophy-section__text">
                  {leftColumn}
                </p>
              )}
            </div>
            <div className="philosophy-section__column philosophy-section__column--right">
              {Array.isArray(rightColumn) ? (
                rightColumn.map((paragraph, index) => (
                  <p key={index} className="philosophy-section__text">
                    {paragraph}
                  </p>
                ))
              ) : (
                <p className="philosophy-section__text">
                  {rightColumn}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
